import React from "react";
import { Row, Col, Input, Button, Select, Space } from "antd";
import { CustomLabel } from "../../../../../utilities/utll";
import { useTradeStore } from "../../../../../store/vendorRegistrationStore/useTradeStore";
import LuxuryCheckbox from "../../../../../common/Checkbox";
import { useVendorMasterStore } from "../../../../../store/useVendorMasterStore";

export default function TurnOverTable({
  data,
  turnOverYears,
  addRow,
  updateRow,
  removeRow,
  submitted,
  editInStep4,
}) {
  const { errors } = useTradeStore();
  const { checkBoxes, setCheckbox } = useVendorMasterStore();
  const approve = localStorage.getItem("showApprove") === "true";
  const lastThreeYears = turnOverYears.slice(0, 3);

  return (
    <div style={{ margin: "16px 0" }}>
      {/* Add Button */}
      {/* <Button
        type="primary"
        onClick={addRow}
        style={{ marginBottom: 10, marginTop: 0 }}
        disabled={!editInStep4}
      >
        + Add
      </Button> */}

      <Row
        style={{
          marginBottom: "10px",
          background: "#f5f5f5",
          padding: "8px 0",
          borderRadius: "4px",
          paddingLeft: 10,
        }}
      >
        <Col xl={4} lg={4} md={4} sm={12} xs={24}>
          <label
            style={{
              fontSize: "14px",
              fontWeight: "500",
              display: "block",
            }}
          >
            Financial Year
            <span style={{ color: "red", marginLeft: "4px" }}>*</span>
          </label>
        </Col>
        <Col xl={4} lg={4} md={4} sm={12} xs={24}>
          <label
            style={{
              fontSize: "14px",
              fontWeight: "500",
              display: "block",
            }}
          >
            {"Turnover Amount (In Lakhs)"}
            <span style={{ color: "red", marginLeft: "4px" }}>*</span>
          </label>
        </Col>
        {submitted && (
          <Col xl={4} lg={4} md={4} sm={12}>
            <LuxuryCheckbox
              id={"last3YearTurnover"}
              label="Checked"
              checked={checkBoxes.last3YearTurnover}
              onChange={(e) =>
                setCheckbox("last3YearTurnover", !checkBoxes.last3YearTurnover)
              }
              disabled={!approve}
            />
          </Col>
        )}
      </Row>
      {/* {data.map((row, index) => (
        <Row
          key={index}
          gutter={[16, 8]}
          align="middle"
          style={{ marginBottom: 8 }}
        >
          
          <Col xl={6} lg={6} md={6} sm={12} xs={24}>
            <Select
              style={{ width: "100%" }}
              placeholder="Select Year"
              value={row.financialYear}
              disabled={!editInStep4}
              options={turnOverYears.map((year) => ({
                label: year,
                value: year,
                disabled: data.some(
                  (r, i) => i !== index && r.financialYear === year
                ),
              }))}
              onChange={(val) => updateRow(index, "financialYear", val)}
            />
          </Col>

     
          <Col xl={6} lg={6} md={6} sm={12} xs={24}>
            <Input
              type="text"
              placeholder="Turnover Amount"
              style={{ width: "100%" }}
              value={row.turnoverAmount}
              onChange={(e) => {
                const val = e.target.value;
                if (/^\d*\.?\d{0,2}$/.test(val)) {
                  updateRow(index, "turnoverAmount", Number(val));
                }
              }}
              disabled={!editInStep4}
            />
          </Col>

        
          <Col>
            {index > 0 && (
              <Button danger onClick={() => removeRow(index)}
              disabled={!editInStep4}>
                X
              </Button>
            )}
          </Col>
        </Row>
      ))} */}
      {/* Fixed 3 Rows */}
      {lastThreeYears.map((year, index) => (
        <Row key={index} gutter={[16, 8]}  style={{marginBottom:"8px"}}>
          <Col xl={3} lg={3} md={6} sm={12} xs={24}>
            <Select
              style={{ width: "100%" }}
              value={year}
              disabled
              options={lastThreeYears.map((y) => ({
                label: y,
                value: y,
              }))}
            />
          </Col>

          <Col xl={6} lg={6} md={6} sm={12} xs={24}>
            <Input
              type="number"
               value={data[index]?.turnoverAmount} 
              disabled={!editInStep4}
              onChange={(e) =>
                updateRow(index, "turnoverAmount", Number(e.target.value))
              }
            />
          </Col>
        </Row>
      ))}
      {errors?.lastThreeYearTurnover && (
        <span style={{ color: "red", fontSize: "12px" }}>
          {errors?.lastThreeYearTurnover}
        </span>
      )}
    </div>
  );
}
